export default {
      id: "ic_nav_iddaa_finger-usage",
      viewBox: "0 0 40 30",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_iddaa_finger-usage",
      toString: function () {
        return this.url;
      }
    }